export default __webpack_public_path__ + "static/media/thumbnail0.b852a963.jpg";